import { $tag, TaggedEnumUnion, tagEnum } from '@suntex.core/types';

import { buildStaticContext } from '../utils';

const $ = 'EntityLevel';

export const EntityLevel = {
  None: tagEnum($, -1),
  Player: tagEnum($, 0),
  Team: tagEnum($, 1),
  School: tagEnum($, 2),
  District: tagEnum($, 3),
  Region: tagEnum($, 4),
  State: tagEnum($, 5),
  All: tagEnum($, 99),
} as const;

export type EntityLevel = TaggedEnumUnion<typeof EntityLevel>;

export const $EntityLevel = buildStaticContext({
  [$tag]: $,
  [EntityLevel.None]: {
    value: EntityLevel.None,
    slug: 'none',
    label: 'None',
  },
  [EntityLevel.Player]: {
    value: EntityLevel.Player,
    slug: 'player',
    label: 'Player',
  },
  [EntityLevel.Team]: {
    value: EntityLevel.Team,
    slug: 'team',
    label: 'Team',
  },
  [EntityLevel.School]: {
    value: EntityLevel.School,
    slug: 'school',
    label: 'School',
  },
  [EntityLevel.District]: {
    value: EntityLevel.District,
    slug: 'district',
    label: 'District',
  },
  [EntityLevel.Region]: {
    value: EntityLevel.Region,
    slug: 'region',
    label: 'Region',
  },
  [EntityLevel.State]: {
    value: EntityLevel.State,
    slug: 'state',
    label: 'State',
  },
  [EntityLevel.All]: {
    value: EntityLevel.All,
    slug: 'all',
    label: 'All',
  },
} as const);
